import type { ActivityRoboticStatus, RoboticStatus } from '@/libs/fleet-api/services/robotic';
import { Tag } from 'antd';
import { FC } from 'react';

type Props = {
	status: RoboticStatus | ActivityRoboticStatus;
};

const STATUS_COLOR_MAP: Record<string, string> = {
	Pending: 'orange',
	Finish: 'green',
	Waiting: 'default',
	'In Queueing': 'blue',
	'In Progress': 'processing',
};

const RoboticStatusBadge: FC<Props> = ({ status }) => {
	const color = STATUS_COLOR_MAP[status] ?? 'default';
	return <Tag color={color}>{status}</Tag>;
};

export default RoboticStatusBadge;
